/**
 * This module contains generated types and helper functions for the package `AptosFramework`.
 *
 * @module
 */

export * as aptos_framework_account from "./account/index.js";
export * as aptos_framework_aggregator from "./aggregator/index.js";
export * as aptos_framework_aggregator_factory from "./aggregator_factory/index.js";
export * as aptos_framework_aptos_coin from "./aptos_coin/index.js";
export * as aptos_framework_aptos_governance from "./aptos_governance/index.js";
export * as aptos_framework_block from "./block/index.js";
export * as aptos_framework_bucket_table from "./bucket_table/index.js";
export * as aptos_framework_chain_id from "./chain_id/index.js";
export * as aptos_framework_code from "./code/index.js";
export * as aptos_framework_coin from "./coin/index.js";
export * as aptos_framework_coins from "./coins/index.js";
export * as aptos_framework_consensus_config from "./consensus_config/index.js";
export { errmap as aptos_framework_errmap } from "./errmap.js";
export * as aptos_framework_gas_schedule from "./gas_schedule/index.js";
export * as aptos_framework_genesis from "./genesis/index.js";
export * as aptos_framework_governance_proposal from "./governance_proposal/index.js";
export * as aptos_framework_managed_coin from "./managed_coin/index.js";
export * as aptos_framework_optional_aggregator from "./optional_aggregator/index.js";
export * as aptos_framework_reconfiguration from "./reconfiguration/index.js";
export * as aptos_framework_resource_account from "./resource_account/index.js";
export * as aptos_framework_stake from "./stake/index.js";
export * as aptos_framework_staking_config from "./staking_config/index.js";
export * as aptos_framework_system_addresses from "./system_addresses/index.js";
export * as aptos_framework_timestamp from "./timestamp/index.js";
export * as aptos_framework_transaction_context from "./transaction_context/index.js";
export * as aptos_framework_transaction_fee from "./transaction_fee/index.js";
export * as aptos_framework_util from "./util/index.js";
export * as aptos_framework_version from "./version/index.js";
export * as aptos_framework_voting from "./voting/index.js";
